import React from 'react';
import { m } from 'framer-motion';
import { PrimaryButton } from '../ui/PrimaryButton';
import { trackMetaEvent } from '../../utils/metaPixel';
import { CHECKOUT_URL } from '../../utils/checkout';
export function FinalCTA() {
  return <section className="bg-navy py-12 sm:py-16" data-id="element-49" data-mp="3mt8qlj7nr311">
      <div className="mx-auto max-w-2xl px-4 text-center sm:px-6" data-id="element-50" data-mp="3rsbnggdhi2xx">
        <h2 className="font-heading text-3xl font-extrabold uppercase leading-tight text-white sm:text-4xl" data-id="element-51" data-mp="3rqs94vbe21ys">
          No esperes al próximo semestre.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-white/75 sm:text-lg" data-id="element-52" data-mp="3hvgojwdau0j4">
          Mañana ya puedes usar la primera clase lista.
        </p>
        <p className="mt-2 font-semibold text-orange" data-id="element-53" data-mp="38tzdiser0p1a">19€. Acceso de por vida. Garantía 7 días.</p>

        <m.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="mt-8 flex justify-center" data-id="element-54" data-mp="123je3cufftbi">
          <PrimaryButton size="lg" href={CHECKOUT_URL} onClick={() => trackMetaEvent('InitiateCheckout', {
          value: 19,
          currency: 'EUR'
        })} data-id="element-55" data-mp="q7llhnlwv12h">
            Acceso Ahora — 19€
          </PrimaryButton>
        </m.div>

        <p className="mt-4 text-xs text-white/60" data-id="element-56" data-mp="uzbyy2g5a4y4">Dinero de vuelta si no funciona. Sin preguntas.</p>
      </div>
    </section>;
}